import { ColDef } from '@ag-grid-community/core'
import { customDateComparator } from '@utils/tableGridUtils'

export const GFPASummaryTableColumns: ColDef[] = [
  {
    field: 'date_col',
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: customDateComparator,
      buttons: ['reset'],
    },
  },
  {
    field: 'p',
  },
  {
    field: 'b',
  },
  {
    field: 'd',
  },
]
